import { SxProps, useTheme } from '@mui/material';
import { isMobileOnly } from 'react-device-detect';

import { useMytaverse } from '@providers/MytaverseProvider';
import { colors } from '@constants/colors';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { appTheme } = useMytaverse();
  const { breakpoints } = useTheme();

  const {
    submitButton: { backgroundColorHover },
  } = appTheme.avatarPage.assets;

  return {
    root: {
      '& .MuiBackdrop-root': {
        backgroundColor: 'transparent',
      },
    },
    container: {
      display: 'flex',
      gap: 0.5,
      flexDirection: 'column',
      justifyContent: 'start',
      padding: 2,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 838,
      background: '#0C0B0B99',
      borderRadius: 6,
      maxHeight: '90vh',
      maxWidth: '90vw',
      overflow: 'auto',
      backdropFilter: 'blur(40px)',
      border: '1.6px solid rgba(255, 255, 255, 0.25)',

      '&:focus-visible': {
        outline: 'none',
      },

      [breakpoints.down(ScreenSizes.PcWide)]: {
        width: 712,
        maxHeight: '80dvh',
        maxWidth: '80dvw',
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        width: 400,
        padding: 0,
        maxHeight: '90dvh',
        maxWidth: '90dvw',
        borderRadius: 4,
        border: 0,
        backdropFilter: 'blur(20px)',
      },
      ...(isMobileOnly
        ? {
            borderRadius: 4,
            border: 0,
            width: 400,
            padding: 0,
            backdropFilter: 'blur(20px)',
          }
        : {}),
    } as SxProps,
    closeIcon: {
      position: 'absolute',
      top: 20,
      right: 20,
      color: colors.grey_200,
      fontSize: 18,
      cursor: 'pointer',
      zIndex: 2,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        top: 10,
        right: 10,
        fontSize: 24,
      },
      ...(isMobileOnly ? { fontSize: 24 } : {}),
    },
    title: {
      fontFamily: 'var(--primary-font-bold)',
      fontWeight: 700,
      fontSize: 32,
      lineHeight: 1,
      color: colors.white,
      marginBottom: 2.5,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        fontSize: 22,
        marginBottom: 1.5,
        display: 'none',
      },
      ...(isMobileOnly ? { display: 'none' } : {}),
    },
    content: {
      display: 'flex',
      background: '#0C0B0B99',
      borderRadius: 4,

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        background: 'transparent',
        borderRadius: 0,
        backdropFilter: 'none',
      },
      ...(isMobileOnly
        ? { background: 'transparent', borderRadius: 0, backdropFilter: 'none' }
        : {}),
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      gap: 1,
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center',

      '@media (max-width: 767px)': {
        gap: 2,
      },

      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        display: 'none',
      },
    },
  };
};
